export default "__VITE_ASSET__BWBVpTx2__"